<template>
  <div>
    <div
      v-show="currentSearch.departure !== currentSearch.destination"
      class="no-drop-link"
      :class="{ selected: selected }"
      @click="onClick"
    >
      <img src="@/assets/car.svg" alt="" />
    </div>
    <div v-show="isDialogOpen" class="background" @click="onClose"></div>
    <div v-show="isDialogOpen" class="dialog">
      <p class="description">
        {{
          current === "RouteSearch"
            ? "目的地周辺でおすすめスポットがあります。"
            : "周辺におすすめスポットがあります。"
        }}
        <br />
        {{
          current === "RouteSearch"
            ? "どこかで立ち寄りしませんか？"
            : "どこかに立ち寄ってから出発しませんか？"
        }}
      </p>

      <ButtonTextLink
        class="gotohere"
        text="周辺スポットを見る"
        @click-text="onClose"
      />
      <ButtonTextLink
        class="gotohere"
        text="立ち寄りせずに進む"
        :isRed="true"
        @click-text="onClickNoDrop"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "congestion-status-dialog",
  components: {
    ButtonTextLink,
  },
  props: {
    selected: { type: Boolean, default: false, required: true },
    current: { type: String, default: false, required: true },
  },
  data() {
    return {
      isDialogOpen: true,
    };
  },
  computed: {
    ...mapState(["selectedFilter", "DesLatLng", "search"]),
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
  },
  methods: {
    ...mapMutations(["setDropDestionaton", "setSearchState"]),
    onClick() {
      this.isDialogOpen = true;
    },
    onClose() {
      this.$emit("clickSeachNearSpots");
      this.isDialogOpen = false;
    },
    onClickNoDrop() {
      this.setSearchState("result");
      this.isDialogOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.gotohere {
  margin: 1rem auto 0;
}
.no-drop-link {
  text-align: center;
  border-radius: 4px;
  padding-top: 2px;
  width: 32px;
  height: 32px;
  position: absolute;
  right: 0.25rem;
  bottom: 8.5rem;
  background: white;
  justify-content: center;
  display: flex;
  align-items: center;
  &.selected {
    bottom: 14rem;
  }
  img {
    height: 20px;
    width: 20px;
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  text-align: center;
  justify-content: center;
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 1.5rem * 2);
  overflow-y: scroll;
  padding: 1rem 0.75rem;
  border-radius: 12px;
}
.description {
  font-size: 1rem;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelect/NoDropDialog.vue